// extracted by mini-css-extract-plugin
module.exports = {"hotel-button":"_93444fe79c--hotel-button--eNZV7"};